import type { Location } from '@partou/my-group/data';

export const MOCK_LOCATIONS = {
  kerkstraat: { id: 'loc-1', name: 'Kerkstraat 45' },
  singel: { id: 'loc-2', name: 'Singel 25' },
  prinsHendrikkade: { id: 'loc-3', name: 'Prins Hendrikkade 50' },
  westerstraat: { id: 'loc-4', name: 'Westerstraat 99' },
  keizersgracht: { id: 'loc-5', name: 'Keizersgracht 123' },
  vondelparkweg: { id: 'loc-6', name: 'Vondelparkweg 8' },
} as const satisfies Record<string, Location>;

const EXTRA_LOCATION_NAMES: ReadonlyArray<string> = [
  'Herengracht 210',
  'Prinsengracht 17',
  'Spuistraat 88',
  'Damrak 12',
  'Rokin 60',
  'Leidsestraat 35',
  'Utrechtsestraat 9',
  'Haarlemmerdijk 120',
  'Bilderdijkstraat 78',
  'Overtoom 244',
  'Ferdinand Bolstraat 31',
  'Albert Cuypstraat 150',
  'Van Woustraat 64',
  'Ceintuurbaan 92',
  'Sarphatistraat 7',
  'Weteringschans 26',
  'Marnixstraat 311',
  'Rozengracht 54',
  'Elandsgracht 40',
  'Lijnbaansgracht 282',
  'Nieuwezijds Voorburgwal 147',
  'Oudezijds Achterburgwal 33',
  'Plantage Middenlaan 18',
  'Sarphatipark 5',
  'Frederiksplein 52',
  'Weesperstraat 113',
  'Wibautstraat 80',
  'Linnaeusstraat 21',
  'Javastraat 66',
  'Molukkenstraat 99',
  'Insulindeweg 14',
  'Czaar Peterstraat 155',
  'Eerste Oosterparkstraat 88',
  'Tweede Oosterparkstraat 19',
  'Beukenplein 6',
  'Middenweg 220',
  'Kruislaan 400',
  'Borneostraat 47',
  'Sumatrakade 1207',
];

const EXTRA_LOCATIONS: ReadonlyArray<Location> = EXTRA_LOCATION_NAMES.map(
  (name: string, index: number): Location => ({ id: `loc-${index + 7}`, name }),
);

export const MOCK_LOCATIONS_LIST: ReadonlyArray<Location> = [...Object.values(MOCK_LOCATIONS), ...EXTRA_LOCATIONS];
